import { render, staticRenderFns } from "./DraftAttachment.vue?vue&type=template&id=ce1b77c2&scoped=true&"
import script from "./DraftAttachment.vue?vue&type=script&lang=js&"
export * from "./DraftAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DraftAttachment.vue?vue&type=style&index=0&id=ce1b77c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1b77c2",
  null
  
)

export default component.exports